<template>
  <div>
    <div class="father" style="display: block">
      <div style="" class="dyh-line-group">
        <b class="dyh-line-group-label">配置店铺支付</b>
        <el-button type="primary" plain size="small" style="width: 150px"
          @click="dialogChange('create')">新增配置</el-button>
      </div>
      <div class="center body-table dyh-body-table" style="width: 100%;">
        <el-table ref="wtyTableRef" border :fit="true" :data="pay_list" size="mini" type="index" height="530px"
          class="show-table" style="height: 100%; width: calc(100% - 20px)" :cell-style="{ padding: '0px 0' }"
          :header-cell-style="{
            height: '20px',
            background: '#409eff',
            color: '#fff',
          }">
          <el-table-column type="index" align="center" label="行号" :width="50">
          </el-table-column>
          <el-table-column v-for="(item, index) in pay_column"
            :formatter="item.prop === 'create_time' || item.prop === 'channel_no' ? formatter : null" :key="index"
            :prop="item.prop" :align="item.align" :label="item.label" :width="item.width"><!-- formatter 数据过滤 -->
          </el-table-column>

          <el-table-column align="center" width="250px" fixed="right" label="操作">
            <template slot-scope="scope">
              <el-button type="text" style="color: #409eff;" @click="dialogChange('modify', scope.row)"
                size="mini">修改配置</el-button>
              <el-button style="color:red;" type="text" @click="dialogChange('del', scope.row)"
                size="mini">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-dialog :title="payConfigureTitle" top="7vh" :close-on-click-modal="false" :visible.sync="dialogVisible"
        width="650px" :before-close="handleClose">
        <el-form ref="form" :model="pay_info" label-width="80px">
          <el-form-item label="默认配置">
            <el-switch v-model="pay_info.is_default"></el-switch>
          </el-form-item>
          <el-form-item label="店铺id">
            <el-input v-model="pay_info.merchant_id"></el-input>
          </el-form-item>
          <el-form-item label="门店号">
            <el-input v-model="pay_info.branch_no"></el-input>
          </el-form-item>
          <el-form-item label="终端设备">
            <el-select style="width:500px !important" v-model="pay_info.terminal" multiple filterable allow-create
              default-first-option placeholder="请选择文章标签">
              <el-option v-for="item in terminal_options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="通道号">
            <el-select style="width:500px !important" v-model="pay_info.channel_no" placeholder="请选择文章标签">
              <el-option v-for="item in channel_options" :key="item.channel_no" :label="item.channel_name"
                :value="item.channel_no">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="店铺号">
            <el-input v-model="pay_info.mch_no" placeholder="请输入商户在渠道的商户号"></el-input>
          </el-form-item>
          <el-form-item label="店铺名称">
            <el-input v-model="pay_info.mch_name" placeholder="请输入显示在用户支付界面的店铺名"></el-input>
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="pay_info.remark" placeholder="请输入备注信息"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="onSubmit">立即创建</el-button>
            <el-button>取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { timeFun } from "@/js/public.js";
//eslint-disable-next-line
import { baseListChanner, basePayConfigure, basePayQuery, basePayDelete } from "@/api/merchant.js";
export default {
  data() {
    return {
      payConfigureTitle: "新建支付配置",
      dialogVisible: false,
      terminal_options: [], //终端设备列表
      channel_options: [], //所有可选通道
      pay_info: {
        merchant_id: localStorage.getItem("merchant_id"),
        branch_no: "",
        terminal: [],
        is_default: false,
        channel_no: "", //通道号
        mch_no: "", //渠道店铺号
        mch_name: "", //店铺名称
        remark: ""
      },
      pay_column: [
        {
          prop: "merchant_id",
          align: "center",
          label: "店铺id",
          width: "",
          fixed: false
        },
        {
          prop: "mch_name",
          align: "center",
          label: "店铺名称",
          width: "",
          fixed: false
        },
        {
          prop: "channel_no",
          align: "center",
          label: "收款通道",
          width: "",
          fixed: false
        },
        {
          prop: "branch_no",
          align: "center",
          label: "门店号",
          width: "",
          fixed: false
        },
        {
          prop: "terminal",
          align: "center",
          label: "终端设备",
          width: "",
          fixed: false
        },
        {
          prop: "mch_no",
          align: "center",
          label: "通道店铺号",
          width: "",
          fixed: false
        },
        {
          prop: "create_time",
          align: "center",
          label: "创建时间",
          width: "",
          fixed: false
        }
      ], //支付配置列
      pay_list: [] //所有支付配置
    }
  },
  mounted() {
    this.getChanner();
    this.basePayQuery();
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
    },
    /**
     * 模态框显示
     * @param {"modify"|"create"|"del"} k 操作
     */
    async dialogChange(k, v) {
      console.log(v);
      console.log(k);
      console.log("支付配置：", arguments);
      switch (k) {
        case "modify":
          this.dialogVisible = true;
          this.payConfigureTitle = "修改配置";
          this.pay_info = v;
          break;
        case "create":
          this.dialogVisible = true;
          this.payConfigureTitle = "新建支付配置";
          this.pay_info = {
            merchant_id: localStorage.getItem("merchant_id"),
            branch_no: "",
            terminal: [],
            is_default: false,
            channel_no: "", //通道号
            mch_no: "", //渠道店铺号
            mch_name: "", //店铺名称
            remark: ""
          };
          break;
        case "del":
          this.deleteBasePay(v.setting_id);
          break
      }
    },
    /**
     * 数据过滤
     * @param row 返回的行数据
     * @param column 返回的列信息
     */
    formatter(row, column) {
      if (column.property === "create_time") {
        return timeFun("cn", row.create_time)
      } else if (column.property === "channel_no") {
        let channel = this.channel_options.find(item => item.channel_no === row.channel_no);
        return channel ? channel.channel_name : row.channel_no
      }
    },
    async onSubmit() {
      const res = await basePayConfigure(this.pay_info);
      if (res.state === 1) {
        this.successMessage(res.message);
        this.handleClose();
        this.basePayQuery();
      }
    },
    /**
     * 获取所有支付通道
     */
    async getChanner() {
      const res = await baseListChanner();
      if (res.length) {
        this.channel_options = res;
      }
    },
    /**
     * 获取到所有配置
     */
    async basePayQuery() {
      const res = await basePayQuery();
      if (res) {
        this.pay_list = res;
      }
      //console.log("获取店铺", res);
    },
    /**
     * 删除支付配置
     * @param {string} setting_id 配置id
     */
    async deleteBasePay(setting_id) {
      console.log("setting_id", setting_id);
      /* const res = await basePayDelete(setting_id);
      console.log("删除支付配置：", res);
      if (res.state === true) {
        this.successMessage(res.message);
        this.basePayQuery();//重新获取支付配置
      } */
    }
  }
}
</script>
<style lang="less" scoped>
.father {
  height: 100%;
  background-color: transparent;
}

.el-input {
  width: 500px;
}
</style>